import { Injectable } from '@angular/core';
import { DmagStateService } from './dmag-state.service';

/**
 * Servizio per la gestione dei moduli dell'utente loggato
 *
 * @export
 * @class DmagModuleService
 */
@Injectable({
  providedIn: 'root',
})
export class DmagModuleService {
  constructor(private stateService: DmagStateService) {}
  /**
   * Controlla se l'utente ho determinati moduli associati.
   *
   * @param {string} modulo
   * @returns {boolean}
   * @memberof DmagModuleService
   */
  hasModule(modulo: string): boolean {
    if (!modulo) {
      return false;
    }

    // Controlla di essere loggati
    const profilo = this.stateService.state.profilo;
    if (!profilo) {
      return false;
    }

    // ---- Controlla i moduli
    const moduli = profilo.moduli;

    // Controlla che ci sia un modulo associato
    return moduli?.includes(modulo);
  }
}
